import { UseFormReturn, Controller } from "react-hook-form";
import TextField from "@/components/TextField";
import Button from "@/components/Button";
import classNames from "classnames";

interface EventRecapFormData {
  eventRecap: string;
}

interface EditEventRecapCardProps {
  form: UseFormReturn<EventRecapFormData>;
  onSubmit: (formData: EventRecapFormData) => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

export default function EditEventRecapCard({ form, onSubmit, onCancel, isSubmitting }: EditEventRecapCardProps) {
  return (
    <div className="space-y-6 w-full">
      <div className="col-span-full">
        <Controller
          control={form.control}
          name="eventRecap"
          render={({ field }) => (
            <TextField
              label="Event Recap"
              type="textarea"
              rows={6}
              value={field.value}
              onChange={(e) => field.onChange((e.target as HTMLInputElement)?.value || "")}
              supportingText="Setting, National and Section staff in attendance, speaking opportunities, highlights, marketing materials used, etc."
            />
          )}
        />
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <Button variant="outlined" disabled={isSubmitting} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          iconClassName={classNames(isSubmitting && "animate-spin w-6 h-6 !block")}
          disabled={isSubmitting}
          icon={isSubmitting ? "progress_activity" : undefined}
          onClick={() => onSubmit(form.getValues())}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
